import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Guid } from 'guid-typescript';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom, take } from 'rxjs';
import { AvenantDocument } from 'src/app/api/models/avenantDocument.model';
import { PolicyDocumentType } from 'src/app/api/models/policyDocumentType';
import { DevisDocumentType } from 'src/app/api/models/quotationDocumentType';
import { DocumentService } from 'src/app/api/services/document.service';
import { EndorsementService } from 'src/app/api/services/endorsement.service';
import { PoliciesService } from 'src/app/api/services/policies.service';
import { AppResource } from 'src/app/app.resource';
import { MimeType } from 'src/app/core/enums/mime-type.enum';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { Contract, Devis, Endorsement } from 'src/app/core/models/form-state.model';
import { Stepper } from 'src/app/core/models/stepper.model';
import * as fromContext from 'src/app/core/state/context';
import * as fromContract from 'src/app/core/state/contract';
import { State } from 'src/app/core/state/core.state';
import * as fromDevis from 'src/app/core/state/devis';
import * as fromElectronicSignature from 'src/app/core/state/electronic-signature';
import * as fromEndorsement from 'src/app/core/state/endorsement';
import * as fromInfo from 'src/app/core/state/info';
import * as fromPayment from 'src/app/core/state/payment';
import { PaymentState } from 'src/app/core/state/payment';
import * as fromSubscriber from 'src/app/core/state/subscriber';
import { SubscriberState } from 'src/app/core/state/subscriber';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { VYV_BRAND } from 'src/app/shared/constants/brand.constants';
import {
  CERTIFICATE_EXPIRED,
  CERTIFICATE_PIN_INCORRECT,
  MAXIMUM_INCORRECT_CERTIFICATE_PIN_ATTEMPTS_REACHED
} from 'src/app/shared/constants/error.constants';
import { TEL } from 'src/app/shared/constants/phone-number.constants';
import { REGEX_E_SIGNATURE } from 'src/app/shared/constants/regex.constants';
import { CONFIRM__AMENDMENT_PATH, ROOT_PATH } from 'src/app/shared/constants/route.constants';
import { getMetropolePhoneNumber } from 'src/app/shared/helpers/metropole-helper.service';
import { HeaderVM } from 'src/app/shared/models/components/headerVm';
import { InfoTopVM } from 'src/app/shared/models/components/infotopVm';
import { QuestionVM } from 'src/app/shared/models/components/questionVm';
import { SignatureVMAvenant } from 'src/app/shared/models/components/signatureVmAvenant';
import { ElectronicSignatureEnum } from 'src/app/shared/models/enum/electronicsignature.enum';
import { ApiRequestBodyUtils } from 'src/app/shared/utils/apiRequestBodyUtils';
import { isMobile } from 'src/app/shared/utils/deviceUtils';
import { environment } from 'src/environments/environment';
import { String } from 'typescript-string-operations';
import * as fromPath from '../../../core/state/path';
import { isPartner } from 'src/app/shared/utils/brandUtils';

@Component({
  selector: 'app-electronic-signature-amendment',
  templateUrl: './electronic-signature-amendment.component.html',
  styleUrl: './electronic-signature-amendment.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ElectronicSignatureAmendmentComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild('pdfViewer') pdfViewer!: PdfViewerComponent;
  @ViewChild('pdfViewer2') pdfViewer2!: PdfViewerComponent;
  headerStep!: HeaderVM;
  override question!: QuestionVM;
  signatureVm!: SignatureVMAvenant;
  electronicSignatureEnum = ElectronicSignatureEnum;
  contrat!: Contract;
  endorsement: Endorsement[] = [];
  devis!: Devis;
  subscriber!: SubscriberState;
  endorsementDocuments: AvenantDocument[] = [];
  paymentData!: PaymentState;
  path!: PathType;
  PolicyDocumentType = PolicyDocumentType;
  numericCodeForm!: FormGroup;
  infoTop!: InfoTopVM;
  agreementId!: Guid;

  context!: string;
  productName: string = '';
  reference: string = '';
  buttonText: string = '';
  cgFile: string = '';
  dipaFile: string = '';
  currentEndorsementIndex: number = 0;
  sansEffetPhoneNumber: string = '';

  displayContextErrorModal: boolean = false;
  condP: boolean = true;
  infoB: boolean = false;
  sepa: boolean = false;
  isChecked: boolean = false;
  condPCheck: boolean = false;
  infoCheck: boolean = false;
  sepaCheck: boolean = false;
  isLoading: boolean = false;
  stepB: boolean = false;
  displayError: boolean = false;
  displayErrorText: boolean = false;
  showCantSignModal: boolean = false;
  errorBadCodeSMS: boolean = false;
  errorCodeSMS: string | undefined;

  displayModal: boolean = false;
  titleModal!: string;
  descriptionModal!: string;
  signatureToken!: string;

  currentPdfUrl: string | null = null;
  currentDocumentType: ElectronicSignatureEnum = ElectronicSignatureEnum.CondP;
  isDocumentLoading: boolean = false;

  get brand() {
    return environment.brand;
  }

  get NOne() {
    return this.numericCodeForm.get('NOne');
  }

  get NTwo() {
    return this.numericCodeForm.get('NTwo');
  }

  get NThree() {
    return this.numericCodeForm.get('NThree');
  }

  get NFour() {
    return this.numericCodeForm.get('NFour');
  }

  get NFive() {
    return this.numericCodeForm.get('NFive');
  }

  get NSix() {
    return this.numericCodeForm.get('NSix');
  }

  constructor(
    private spinner: NgxSpinnerService,
    store: Store<State>,
    resources: AppResource,
    private documentService: DocumentService,
    @Inject(EndorsementService) private endorsementService: EndorsementService,
    private policyService: PoliciesService,
    private elementRef: ElementRef,
    private router: Router
  ) {
    super(store, resources);
    this.headerStep = new HeaderVM(
      isPartner(this.brand)
        ? this.resource.header.stepContract
        : this.resource.header.stepSignature,
      3,
      this.resource.header.subStepSignatureAmemdment,
      9
    );
  }

  override async ngOnInit() {
    super.ngOnInit();
    this.spinner.show();
    this.signatureVm = new SignatureVMAvenant('', '');
    this.initForm();
    await this.loadStateData();
    this.updateButtonText();
    if (this.context) {
      this.initVm();
      this.getSansEffetPhoneNumber();
    } else {
      this.displayContextErrorModal = true;
    }
  }

  ngOnDestroy() {
    // Nettoyer toutes les ressources
    if (this.signatureVm) {
      if (this.signatureVm.condPUrlEmbed) {
        URL.revokeObjectURL(this.signatureVm.condPUrlEmbed);
      }
      if (this.signatureVm.sepaUrlEmbed) {
        URL.revokeObjectURL(this.signatureVm.sepaUrlEmbed);
      }
    }
    if (this.currentPdfUrl) {
      URL.revokeObjectURL(this.currentPdfUrl);
    }
  }

  private async loadStateData() {
    // Retrieve context
    let contextId = await lastValueFrom(
      this.store.select(fromContext.selectContextId).pipe(take(1))
    );
    this.context = contextId!;

    // Retrieve contract
    this.contrat = await lastValueFrom(
      this.store.select(fromContract.selectContractState).pipe(take(1))
    );
    this.endorsement = await lastValueFrom(
      this.store.select(fromEndorsement.selectEndorsementState).pipe(take(1))
    );
    this.reference = this.endorsement[this.currentEndorsementIndex].RefContrat!;
    this.agreementId = this.endorsement[this.currentEndorsementIndex].NumeroContrat;
    this.productName = this.endorsement[this.currentEndorsementIndex].productName!;
    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    this.paymentData = await lastValueFrom(
      this.store.select(fromPayment.selectPayment).pipe(take(1))
    );

    this.devis = await lastValueFrom(this.store.select(fromDevis.selectDevisState).pipe(take(1)));

    this.subscriber = await lastValueFrom(
      this.store.select(fromSubscriber.selectSubscriber).pipe(take(1))
    );
  }

  updateButtonText() {
    if (this.endorsement.length === 1) {
      this.buttonText = this.resource.signature.receiveCode;
    } else if (this.endorsement.length > 1) {
      this.buttonText =
        this.resource.signature.nextContract +
        ` (${this.currentEndorsementIndex + 1}/${this.endorsement.length})`;
    }
  }

  private initForm() {
    this.numericCodeForm = new FormGroup({
      NOne: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NTwo: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NThree: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NFour: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NFive: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NSix: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      })
    });
  }

  private async initVm() {
    if (this.contrat) {
      this.signatureVm = new SignatureVMAvenant(
        this.contrat.RefDocumentCP,
        this.contrat.RefDocumentMandatSEPA
      );

      if (this.endorsement && this.endorsement.length > 0) {
        this.spinner.show();

        // Créer un ensemble de correlationId uniques
        const uniqueCorrelationIds = new Set<Guid>();
        this.endorsement.forEach(e => {
          if (e.correlationId) uniqueCorrelationIds.add(e.correlationId);
        });

        // Convertir en tableau pour faciliter le traitement
        const correlationIds = Array.from(uniqueCorrelationIds);

        // Variable pour suivre le nombre de requêtes terminées
        let completedRequests = 0;
        this.endorsementDocuments = [];

        // Pour chaque correlationId, charger les documents correspondants
        correlationIds.forEach(correlationId => {
          this.endorsementService.getEndorsementDocuments(correlationId).subscribe({
            next: documents => {
              // Ajouter les documents au tableau global
              if (documents && documents.length > 0) {
                this.endorsementDocuments = [...this.endorsementDocuments, ...documents];
              }

              // Incrémenter le compteur de requêtes terminées
              completedRequests++;

              // Si toutes les requêtes sont terminées, afficher le document courant
              if (completedRequests === correlationIds.length) {
                // S'assurer que les documents sont triés dans le même ordre que les avenants
                this.organizeDocuments();

                // Afficher le document courant
                if (this.endorsementDocuments.length > 0) {
                  const currentDocument = this.findDocumentForEndorsement(
                    this.currentEndorsementIndex
                  );
                  if (currentDocument) {
                    this.setDocumentState(currentDocument, this.signatureVm);
                    this.showDocument(currentDocument);
                  } else {
                    console.error(
                      `Aucun document trouvé pour l'avenant ${this.currentEndorsementIndex}`
                    );
                    this.spinner.hide();
                  }
                } else {
                  console.error('Aucun document chargé');
                  this.spinner.hide();
                }
              }
            },
            error: err => {
              console.error(
                `Erreur lors du chargement des documents pour correlationId ${correlationId}:`,
                err
              );

              // Même en cas d'erreur, incrémenter le compteur
              completedRequests++;

              if (completedRequests === correlationIds.length) {
                // Continuer avec les documents disponibles
                if (this.endorsementDocuments.length > 0) {
                  const currentDocument = this.findDocumentForEndorsement(
                    this.currentEndorsementIndex
                  );
                  if (currentDocument) {
                    this.setDocumentState(currentDocument, this.signatureVm);
                    this.showDocument(currentDocument);
                  } else {
                    this.spinner.hide();
                  }
                } else {
                  this.spinner.hide();
                }
              }
            }
          });
        });
      } else {
        this.signatureVm = new SignatureVMAvenant('', '');
      }
    }
    const paymentPrefixTel =
      this.paymentData.payment.PaymentPrefixTel != null
        ? this.paymentData.payment.PaymentPrefixTel
        : this.paymentData.payment.PrefixeTel;
    const paymentTelephone =
      this.paymentData.payment.PaymentTelephone != null
        ? this.paymentData.payment.PaymentTelephone
        : this.paymentData.payment.Telephone;

    this.infoTop = new InfoTopVM(
      this.resource.infotop.codeConfirmation,
      this.resource.infotop.codeConfirmationS,
      paymentPrefixTel + paymentTelephone,
      this.resource.infotop.logoMessage,
      true
    );

    this.question = new QuestionVM(this.resource.question.signature1);
  }

  setDocumentState(document: AvenantDocument, signatureVm: SignatureVMAvenant) {
    signatureVm.isCondPSigned = document.documentDetails[PolicyDocumentType.CP] !== undefined;
    signatureVm.isSepaSigned = document.documentDetails[PolicyDocumentType.SEPA] !== undefined;
  }

  // Méthode pour organiser les documents dans le même ordre que les avenants
  private organizeDocuments() {
    // Créer un tableau temporaire pour stocker les documents organisés
    const organizedDocuments: AvenantDocument[] = [];

    // Pour chaque avenant, trouver le document correspondant
    this.endorsement.forEach((endorsement, index) => {
      const matchingDocument = this.endorsementDocuments.find(
        doc => doc.agreementId === endorsement.NumeroContrat
      );

      if (matchingDocument) {
        organizedDocuments[index] = matchingDocument;
      } else {
        console.warn(
          `Aucun document trouvé pour l'avenant ${index} (NumeroContrat: ${endorsement.NumeroContrat})`
        );
      }
    });

    // Filtrer les éléments undefined
    this.endorsementDocuments = organizedDocuments.filter(doc => doc !== undefined);
  }

  // Méthode pour trouver le document correspondant à un avenant
  private findDocumentForEndorsement(endorsementIndex: number): AvenantDocument | undefined {
    if (
      !this.endorsement ||
      !this.endorsementDocuments ||
      endorsementIndex >= this.endorsement.length
    ) {
      return undefined;
    }

    const currentEndorsement = this.endorsement[endorsementIndex];
    return this.endorsementDocuments.find(
      doc => doc.agreementId === currentEndorsement.NumeroContrat
    );
  }

  showDocument(document: AvenantDocument) {
    if (document.agreementId === this.endorsement[this.currentEndorsementIndex].NumeroContrat) {
      const cpDocument = document.documentDetails[PolicyDocumentType.CP];
      const sepaDocument = document.documentDetails[PolicyDocumentType.SEPA];
      if (cpDocument === undefined && sepaDocument !== undefined) {
        this.currentDocumentType = ElectronicSignatureEnum.Sepa;
        this.condP = false;
        this.sepa = true;
      } else {
        this.currentDocumentType = ElectronicSignatureEnum.CondP;
        this.condP = true;
        this.sepa = false;
      }

      if (cpDocument !== undefined)
        this.getCPDocument(document.documentDetails[PolicyDocumentType.CP]);
      if (sepaDocument !== undefined)
        this.getMandatSepaDocument(document.documentDetails[PolicyDocumentType.SEPA]);
      this.downloadOtherDocument(
        document.documentDetails[PolicyDocumentType.CG],
        PolicyDocumentType.CG
      );
      this.downloadOtherDocument(
        document.documentDetails[DevisDocumentType.DIPA],
        DevisDocumentType.DIPA
      );
    }
  }

  updateClickButton(value: string) {
    switch (value) {
      case ElectronicSignatureEnum.CondP:
        if (!this.condP) {
          this.condP = !this.condP;
          this.infoB = false;
          this.sepa = false;
        }
        break;
      case ElectronicSignatureEnum.Sepa:
        if (!this.sepa) {
          this.condP = false;
          this.infoB = false;
          this.sepa = !this.sepa;
        }
        break;
    }
  }

  onProgress(progressData: any, documentType: ElectronicSignatureEnum) {
    this.spinner.show();
    if (progressData.loaded == progressData.total) {
      this.spinner.hide();
      switch (documentType) {
        case ElectronicSignatureEnum.CondP:
          this.signatureVm.condPLoaded = true;
          break;
        case ElectronicSignatureEnum.Sepa:
          this.signatureVm.sepaLoaded = true;
          break;
      }
    }
  }

  onPdfError(error: any): void {
    console.error('PDF error:', error);

    // Déterminer quel type de document a échoué
    if (this.currentDocumentType === ElectronicSignatureEnum.CondP) {
      this.signatureVm.condPLoaded = false;
      this.signatureVm.condPUrlEmbed = '';
    } else {
      this.signatureVm.sepaLoaded = false;
      this.signatureVm.sepaUrlEmbed = '';
    }

    this.spinner.hide();
    this.isDocumentLoading = false;
  }

  getClass(value: boolean) {
    return value ? 'active-ES' : 'inactive-ES';
  }

  updateChecks(isChecked: boolean) {
    if (this.endorsement[this.currentEndorsementIndex]) {
      // Create a new object with the updated isChecked property
      const updatedEndorsement = {
        ...this.endorsement[this.currentEndorsementIndex],
        isChecked: isChecked
      };

      // Replace the object in the endorsement array
      this.endorsement = [
        ...this.endorsement.slice(0, this.currentEndorsementIndex),
        updatedEndorsement,
        ...this.endorsement.slice(this.currentEndorsementIndex + 1)
      ];
    } else {
      console.error('Invalid endorsement index:', this.currentEndorsementIndex);
    }
  }

  async validateStepOne() {
    if (this.currentEndorsementIndex < this.endorsement.length - 1) {
      this.currentEndorsementIndex++;
      this.reference = this.endorsement[this.currentEndorsementIndex].RefContrat!;
      this.productName = this.endorsement[this.currentEndorsementIndex].productName!;
      const updatedEndorsement = {
        ...this.endorsement[this.currentEndorsementIndex],
        isChecked: false
      };
      this.endorsement = [
        ...this.endorsement.slice(0, this.currentEndorsementIndex),
        updatedEndorsement,
        ...this.endorsement.slice(this.currentEndorsementIndex + 1)
      ];
      if (
        this.endorsementDocuments &&
        this.currentEndorsementIndex < this.endorsementDocuments.length
      ) {
        this.spinner.show();
        this.condP = true;
        this.sepa = false;
        // Utiliser setTimeout pour s'assurer que le DOM est mis à jour avant de charger les nouveaux documents
        setTimeout(() => {
          this.showDocument(this.endorsementDocuments[this.currentEndorsementIndex]);
        }, 300);
      }
      if (this.currentEndorsementIndex === this.endorsement.length - 1) {
        this.buttonText = this.resource.signature.receiveCode;
      } else {
        this.updateButtonText();
      }
    } else {
      this.isLoading = true;
      this.buttonText = this.resource.signature.receiveCode;
      const paymentPrefixTel =
        this.paymentData.payment.PaymentPrefixTel != null
          ? this.paymentData.payment.PaymentPrefixTel
          : this.paymentData.payment.PrefixeTel;
      const paymentTelephone =
        this.paymentData.payment.PaymentTelephone != null
          ? this.paymentData.payment.PaymentTelephone
          : this.paymentData.payment.Telephone;
      const correlationId = this.endorsement[0].correlationId;
      this.policyService
        .startEndorsementSignatureProcess(correlationId, paymentPrefixTel, paymentTelephone)
        .subscribe({
          next: res => {
            fromElectronicSignature.patchSignature({
              payload: {
                SignatureToken: Object.values(res)[0]
              }
            });
            this.signatureToken = Object.values(res)[0];
            this.question = new QuestionVM(this.resource.question.signature2);
            this.stepB = true;
            this.isLoading = false;
          },
          error: () => {
            this.isLoading = false;
            this.displayError = true;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
    }
  }

  async sendBackSmsCode() {
    const signatureState = await lastValueFrom(
      this.store.select(fromElectronicSignature.selectElectronicSignature).pipe(take(1))
    );
    this.isLoading = true;
    this.policyService
      .resendSmsPinCode(Guid.parse(this.contrat.NumeroContrat)['value'], this.signatureToken ?? '')
      .subscribe({
        next: (res: any) => {},
        error: () => {
          this.isLoading = false;
          this.displayError = true;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  previousEndorsement() {
    if (this.currentEndorsementIndex > 0) {
      // Afficher le spinner pendant le chargement
      this.spinner.show();
      this.isDocumentLoading = true;

      // Réinitialiser les URLs des documents
      if (this.signatureVm) {
        if (this.signatureVm.condPUrlEmbed) {
          URL.revokeObjectURL(this.signatureVm.condPUrlEmbed);
        }
        if (this.signatureVm.sepaUrlEmbed) {
          URL.revokeObjectURL(this.signatureVm.sepaUrlEmbed);
        }
        this.signatureVm.condPUrlEmbed = '';
        this.signatureVm.sepaUrlEmbed = '';
      }

      // Décrémenter l'index et mettre à jour les informations
      this.currentEndorsementIndex--;
      this.reference = this.endorsement[this.currentEndorsementIndex].RefContrat!;
      this.productName = this.endorsement[this.currentEndorsementIndex].productName!;
      this.updateButtonText();

      // Charger le document après un court délai
      setTimeout(() => {
        if (this.endorsementDocuments && this.endorsementDocuments.length > 0) {
          this.showDocument(this.endorsementDocuments[this.currentEndorsementIndex]);
        }
      }, 200);
    }
  }

  async getCPDocument(id: Guid) {
    this.documentService
      .getAgreementDocument(id, this.agreementId, this.subscriber.subscriber?.Email!)
      .subscribe({
        next: data => {
          try {
            if (!data || !data.fileContents) {
              console.error('Invalid CP PDF data');
              this.isDocumentLoading = false;
              this.spinner.hide();
              return;
            }

            const blob = this.documentService.convertBase64ToBlob(
              atob(data.fileContents),
              MimeType.OCTET_STREAM
            );
            const url = window.URL.createObjectURL(blob);

            const blobView = this.documentService.convertBase64ToBlob(
              atob(data.fileContents),
              MimeType.APPLICATION_PDF
            );
            const urlView = URL.createObjectURL(blobView);

            // Important : différer la mise à jour de l'URL pour laisser le temps au DOM de se mettre à jour
            setTimeout(() => {
              this.pdfViewer.ngOnInit();
              this.signatureVm.condPUrlDl = urlView;
              this.signatureVm.condPUrlEmbed = url;
              this.isDocumentLoading = false;
              this.spinner.hide();
            }, 100);
          } catch (error) {
            console.error('Error processing CP document:', error);
            this.isDocumentLoading = false;
            this.spinner.hide();
          }
        },
        error: err => {
          console.error('Error fetching CP document content:', err);
          this.isDocumentLoading = false;
          this.spinner.hide();
        }
      });
  }

  async getMandatSepaDocument(id: Guid) {
    this.documentService
      .getAgreementDocument(id, this.agreementId, this.subscriber.subscriber?.Email!)
      .subscribe({
        next: data => {
          try {
            if (!data || !data.fileContents) {
              console.error('Invalid SEPA PDF data');
              this.isDocumentLoading = false;
              this.spinner.hide();
              return;
            }

            const blob = this.documentService.convertBase64ToBlob(
              atob(data.fileContents),
              MimeType.OCTET_STREAM
            );
            const url = window.URL.createObjectURL(blob);

            const blobView = this.documentService.convertBase64ToBlob(
              atob(data.fileContents),
              MimeType.APPLICATION_PDF
            );
            const urlView = URL.createObjectURL(blobView);

            // Important : différer la mise à jour de l'URL pour laisser le temps au DOM de se mettre à jour
            setTimeout(() => {
              this.pdfViewer2.ngOnInit();
              this.signatureVm.sepaUrlDl = urlView;
              this.signatureVm.sepaUrlEmbed = url;
              this.isDocumentLoading = false;
              this.spinner.hide();
            }, 100);
          } catch (error) {
            console.error('Error processing SEPA document:', error);
            this.isDocumentLoading = false;
            this.spinner.hide();
          }
        },
        error: err => {
          console.error('Error fetching SEPA document content:', err);
          this.isDocumentLoading = false;
          this.spinner.hide();
        }
      });
  }

  downloadOtherDocument(id: Guid, type?: string) {
    this.documentService
      .getAgreementDocument(id, this.agreementId, this.subscriber.subscriber?.Email!)
      .subscribe({
        next: data => {
          try {
            if (!data || !data.fileContents) {
              this.isDocumentLoading = false;
              this.spinner.hide();
              return;
            }

            const blob = this.documentService.convertBase64ToBlob(
              atob(data.fileContents),
              MimeType.OCTET_STREAM
            );
            const url = window.URL.createObjectURL(blob);

            const blobView = this.documentService.convertBase64ToBlob(
              atob(data.fileContents),
              MimeType.APPLICATION_PDF
            );
            const urlView = URL.createObjectURL(blobView);
            if (type === PolicyDocumentType.CG) {
              this.cgFile = urlView;
              this.spinner.hide();
            } else {
              this.dipaFile = urlView;
              this.spinner.hide();
            }
          } catch (error) {
            console.error('Error processing CG document:', error);
            this.isDocumentLoading = false;
            this.spinner.hide();
          }
        },
        error: err => {
          console.error('Error fetching CG document content:', err);
          this.isDocumentLoading = false;
          this.spinner.hide();
        }
      });
  }

  // Method to close the error dialog
  closeErrorModal() {
    this.displayContextErrorModal = false;
  }

  confirmModal() {
    this.displayModal = false;
    this.showCantSignModal = false;
  }

  onKeyUp(event: any, nextValue: string) {
    const input = event.target;
    if (isNaN(input.value)) {
      input.value = '';
      return;
    }
    var nbVal = parseInt(input.value);
    if (nbVal < 0 || nbVal > 9) {
      input.value = '';
      return;
    }
    this.elementRef.nativeElement.querySelector('#' + nextValue).focus();
  }

  async validateStepTwo() {
    this.isLoading = true;

    const codeSms: string =
      this.NOne?.value +
      this.NTwo?.value +
      this.NThree?.value +
      this.NFour?.value +
      this.NFive?.value +
      this.NSix?.value;

    this.store.dispatch(
      fromElectronicSignature.patchSignature({
        payload: {
          CodeSms: codeSms
        }
      })
    );

    this.store.dispatch(
      fromElectronicSignature.changeValidationStatus({
        isValid: true
      })
    );

    // Retrieve signature state
    const signatureState = await lastValueFrom(
      this.store.select(fromElectronicSignature.selectElectronicSignature).pipe(take(1))
    );
    // Validate signature
    const bodySignDocuments = ApiRequestBodyUtils.GenerateSignatureSignRequestBody(
      this.context,
      this.contrat.NumeroContrat,
      signatureState.electronicSignature
    );
    const correlationId = this.endorsement[0].correlationId;
    this.policyService
      .completeEndorsementSignatureProcess(
        correlationId,
        this.signatureToken,
        bodySignDocuments.CodeSMS
      )
      .subscribe({
        next: (res: any) => {
          this.router.navigate([`${ROOT_PATH}${CONFIRM__AMENDMENT_PATH}`]);
        },
        error: resSignature => {
          this.isLoading = false;

          const errorDetail = resSignature.error?.detail;
          const errorCodeMatch = errorDetail?.match(REGEX_E_SIGNATURE);
          const errorCode = errorCodeMatch ? errorCodeMatch[1] : null;

          if (errorCode === CERTIFICATE_PIN_INCORRECT) {
            this.errorCodeSMS = this.resource.error.certificatePinIncorrect;
            this.displayErrorText = true;
          } else if (errorCode === CERTIFICATE_EXPIRED) {
            this.errorCodeSMS = this.resource.error.certificatePinExpired;
            this.displayErrorText = true;
          } else if (errorCode === MAXIMUM_INCORRECT_CERTIFICATE_PIN_ATTEMPTS_REACHED) {
            this.errorCodeSMS = this.resource.error.smsCodeAttemptsExceeded;
            this.displayErrorText = true;
          } else {
            this.displayError = true;
          }

          this.NOne?.setValue('');
          this.NTwo?.setValue('');
          this.NThree?.setValue('');
          this.NFour?.setValue('');
          this.NFive?.setValue('');
          this.NSix?.setValue('');
        },
        complete: () => {
          this.isLoading = false;
          this.displayError = false;
          this.displayErrorText = false;
          this.updateStepper();
        }
      });
  }
  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    var tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.contract.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.signature
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.electronicsignature
    );

    if (subtitleS) {
      subtitleS.isValid = true;
      subtitleS.isActive = true;
    }

    let subtitleNS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.confirmcontract
    );

    if (subtitleNS) {
      subtitleNS.isValid = true;
      subtitleNS.isActive = true;
    }

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  callClientService(): void {
    if (isMobile()) {
      let supportPhoneNumber =
        this.brand === VYV_BRAND
          ? this.sansEffetPhoneNumber.replace(/\s/g, '')
          : this.resource.signature.clientServicePhoneNumber;
      window.location.href = TEL + `${supportPhoneNumber}`;
    }
  }

  getSansEffetPhoneNumber() {
    if (this.path === PathType.HOUSING) {
      this.sansEffetPhoneNumber = this.resource.signature.phoneNumberHousing;
    } else if (this.path === PathType.HOUSING_SOLIDARITY) {
      this.sansEffetPhoneNumber = this.resource.signature.phoneNumberHousingSolidarity;
    } else {
      const phoneNumber = getMetropolePhoneNumber(this.path);
      if (phoneNumber) {
        this.sansEffetPhoneNumber = String.format(
          this.resource.signature.phoneNumberHousingMetropole,
          phoneNumber
        );
      }
    }
  }
}
